<template>
  <dx-offer-intro product="p-combi" />
</template>

<script>
import DxOfferIntro from '~/domains/offer/components/DX-OfferIntro'

export default {
  name: 'PCombiIntro',
  components: {
    DxOfferIntro,
  },
  layout: 'website',
  // maybe use a dynamic layout here some day?
  // layout: ({ store }) => (store.getters.isLoggedIn ? 'default' : 'website'),
  transition: 'none',
  meta: {
    isPublic: true,
    trackingId: 'dextra.privatrechtsschutz.p-kombi.antragsstrecke',
    trackingGroup: ['rechtsschutz', 'privatrechtsschutz'],
  },
  nuxtI18n: {
    paths: {
      de: '/privatrechtsschutz/p-kombi/antragsstrecke/',
      fr: '/protection-juridique-privee/p-combi/formulaire-de-demande/',
    },
  },
}
</script>
